var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExerciseWritting = function SvgExerciseWritting(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#exercise-writting_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m21.404 6.1.12.07c1.038.599 1.903 1.098 2.537 1.587.668.516 1.199 1.108 1.421 1.938s.059 1.608-.262 2.389c-.223.542-.55 1.152-.946 1.847l-.847-.504-.01-.006-9.234-5.331-.864-.51c.4-.68.76-1.263 1.116-1.723.516-.668 1.108-1.2 1.938-1.421.83-.223 1.607-.06 2.389.262.74.304 1.605.804 2.642 1.403M12.317 9.312 7.68 17.344c-.397.686-.711 1.229-.827 1.846-.117.617-.022 1.237.098 2.021l.033.212c.221 1.455.404 2.654.68 3.564.287.951.73 1.775 1.601 2.278.871.502 1.806.474 2.774.248.925-.216 2.055-.658 3.426-1.193l.2-.078c.739-.288 1.323-.516 1.8-.925.476-.41.789-.953 1.185-1.64l4.626-8.013-.865-.514-9.24-5.335z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#exercise-writting_svg__b)",
    strokeLinecap: "round",
    d: "m12.137 8.625.434.256.852.502 9.238 5.334.005.003h0l.866.514.424.252-.247.428-4.626 8.013h0l-.024.042c-.377.653-.727 1.261-1.269 1.727l-.326-.38.326.38c-.541.465-1.196.72-1.898.994l-.045.017h0l-.2.078h0l-.033.013c-1.344.525-2.501.978-3.462 1.202-1.023.24-2.107.292-3.137-.302-1.029-.595-1.525-1.56-1.83-2.566-.286-.944-.473-2.172-.69-3.599l-.006-.035h0l-.032-.211h0l-.007-.048c-.115-.745-.22-1.44-.089-2.142.133-.701.484-1.31.862-1.962l.024-.041zm0 0-.253.437-4.637 8.031zm11.882 5.735.438.26.252-.442c.396-.697.737-1.33.973-1.904.343-.833.545-1.73.283-2.708s-.886-1.655-1.6-2.205c-.66-.509-1.548-1.022-2.563-1.608l-.028-.016h0l-.12-.07h0l-.027-.015c-1.015-.586-1.904-1.1-2.675-1.417-.833-.342-1.731-.544-2.709-.282s-1.654.886-2.204 1.599l.396.305-.396-.305c-.376.487-.75 1.093-1.151 1.776l-.253.43.43.253.864.51h0l.004.002 9.23 5.33h.003l.006.004.003.002z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "exercise-writting_svg__b",
    x1: 6.8,
    x2: 29.603,
    y1: 4.333,
    y2: 22.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "exercise-writting_svg__a",
    width: 68.784,
    height: 73.335,
    x: -18.2,
    y: -20.667,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_388_6227"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_388_6227",
    result: "shape"
  })))));
};
export { SvgExerciseWritting as ReactComponent };